import { render, staticRenderFns } from "./BlogHeader.vue?vue&type=template&id=78c59900&"
import script from "./BlogHeader.vue?vue&type=script&lang=js&"
export * from "./BlogHeader.vue?vue&type=script&lang=js&"
import style0 from "./BlogHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports